import { EventBus } from '@/utils/eventbus';
import dayjs from 'dayjs';

/**
 * 打开登录弹窗
 */
export function openLoginDialogWithMessage() {
  EventBus.$emit('dialogLoginVisible', true);
}

/**
 * 格式化日期
 * @param {String} timestamp 时间戳
 * @param {String} formatString 格式化字符串
 */
export function formatDate(timestamp, formatString) {
  if (!timestamp) return '-';

  timestamp = String(timestamp);
  timestamp = Number(timestamp.padEnd(13, '0'));
  return dayjs(timestamp).format(formatString);
}

/**
 * 下载文件
 * @param {String} url 文件地址
 * @param {String} fileName 文件名
 */
export function fileDownload(url, fileName) {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = "noopener noreferrer";
  a.target = '_blank';
  a.click();
  a.remove();
}

/**
 * 分享链接
 * @param {String} href 分享链接
 * @param {String} title 分享标题
 * @returns {Object} 分享链接对象
 */
export function shareLink(href, title) {
  href = encodeURIComponent(href);
  title = encodeURIComponent(title);

  return {
    qq: `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${href}&title=${title}`,
    weibo: `http://service.weibo.com/share/share.php?url=${href}&title=${title}`,
  };
}
